/* Section initializer — queries by data-section-type so it works without
   Liquid interpolation. */
(function init() {
  document.querySelectorAll('[data-section-type="product-pattern"]').forEach(function(section) {
    if (section.dataset.ppInit) return;
    section.dataset.ppInit = '1';

    /* Lightbox — shared between the main gallery tiles and the tester
       slide rail. The active "source array" is set when the user clicks,
       so prev/next walks whichever set was opened from. */
    var galleryTiles = Array.prototype.slice.call(section.querySelectorAll('[data-gallery-tile]'));
    var makerSlides = Array.prototype.slice.call(section.querySelectorAll('[data-makers-slide]'));
    var galleryGrid = section.querySelector('[data-gallery-grid]');
    var photoDialog = section.querySelector('[data-photo-lightbox]');
    var photoImg = photoDialog ? photoDialog.querySelector('[data-photo-img]') : null;
    var photoPrev = photoDialog ? photoDialog.querySelector('[data-photo-prev]') : null;
    var photoNext = photoDialog ? photoDialog.querySelector('[data-photo-next]') : null;

    var activeItems = galleryTiles;
    var currentItemIdx = 0;

    function syncLightboxToItem(idx) {
      if (!photoImg || !activeItems[idx]) return;
      currentItemIdx = idx;
      var item = activeItems[idx];
      photoImg.src = item.getAttribute('data-zoom-src') || '';
      photoImg.alt = item.getAttribute('data-tile-alt') || '';
    }

    function openPhotoLightbox(items, idx) {
      if (!photoDialog || !photoImg) return;
      activeItems = items;
      syncLightboxToItem(idx);
      /* Hide prev/next when single-item set; show otherwise */
      if (photoPrev) photoPrev.style.display = items.length > 1 ? '' : 'none';
      if (photoNext) photoNext.style.display = items.length > 1 ? '' : 'none';
      document.body.classList.add('pattern-photo-lightbox-open');
      try { photoDialog.showModal(); } catch (e) { photoDialog.setAttribute('open', ''); }
    }
    function closePhotoLightbox() {
      try { photoDialog.close(); } catch (e) { photoDialog.removeAttribute('open'); }
      document.body.classList.remove('pattern-photo-lightbox-open');
    }
    function stepLightbox(delta) {
      if (activeItems.length < 2) return;
      var n = activeItems.length;
      syncLightboxToItem(((currentItemIdx + delta) % n + n) % n);
    }

    galleryTiles.forEach(function(tile, idx) {
      tile.addEventListener('click', function() { openPhotoLightbox(galleryTiles, idx); });
    });
    makerSlides.forEach(function(slide, idx) {
      slide.addEventListener('click', function() { openPhotoLightbox(makerSlides, idx); });
    });

    /* "Tailles, métrage et fournitures" — opens the photo lightbox with the
       hidden info-image set as the active array. */
    var infoImages = Array.prototype.slice.call(section.querySelectorAll('[data-info-image]'));
    var infoOpenBtn = section.querySelector('[data-open-info-images]');
    if (infoOpenBtn && infoImages.length > 0) {
      infoOpenBtn.addEventListener('click', function() {
        openPhotoLightbox(infoImages, 0);
      });
    }

    if (photoDialog) {
      var photoClose = photoDialog.querySelector('[data-photo-close]');
      if (photoClose) photoClose.addEventListener('click', closePhotoLightbox);
      if (photoPrev) photoPrev.addEventListener('click', function() { stepLightbox(-1); });
      if (photoNext) photoNext.addEventListener('click', function() { stepLightbox(1); });
      /* Backdrop click closes (any click directly on the dialog element) */
      photoDialog.addEventListener('click', function(e) {
        if (e.target === photoDialog) closePhotoLightbox();
      });
      photoDialog.addEventListener('close', function() {
        document.body.classList.remove('pattern-photo-lightbox-open');
      });
      photoDialog.addEventListener('keydown', function(e) {
        if (e.key === 'ArrowLeft' && photoPrev) { e.preventDefault(); photoPrev.click(); }
        else if (e.key === 'ArrowRight' && photoNext) { e.preventDefault(); photoNext.click(); }
      });
    }

    /* Mobile pagination dots — built dynamically, kept in sync with the
       visible tile via IntersectionObserver. Desktop layout hides the dots
       via CSS so this code runs harmlessly there too. */
    var dotsContainer = section.querySelector('[data-gallery-dots]');
    if (dotsContainer && galleryGrid && galleryTiles.length > 1) {
      var dotLabelTpl = dotsContainer.getAttribute('data-dot-label') || 'Photo %INDEX%';
      var dots = [];
      galleryTiles.forEach(function(tile, idx) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'pattern-gallery-dot' + (idx === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', dotLabelTpl.replace('%INDEX%', idx + 1));
        dot.addEventListener('click', function() {
          try { tile.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' }); }
          catch(e) { tile.scrollIntoView(); }
        });
        dotsContainer.appendChild(dot);
        dots.push(dot);
      });
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.55) {
              var idx = galleryTiles.indexOf(entry.target);
              if (idx >= 0) {
                dots.forEach(function(d) { d.classList.remove('is-active'); });
                dots[idx].classList.add('is-active');
              }
            }
          });
        }, { root: galleryGrid, threshold: [0.55, 0.75] });
        galleryTiles.forEach(function(t) { io.observe(t); });
      }
    }

    /* Buy Now: add variant to cart via fetch, then redirect straight to
       checkout. The button is locked while the request is in flight to
       prevent double-clicks creating duplicate line items. */
    var buyNowBtn = section.querySelector('[data-buy-now]');
    if (buyNowBtn) {
      buyNowBtn.addEventListener('click', function() {
        // Read the live-selected variant from the form's [data-variants] field
        // (kept in sync by retina's <variant-selection>), not the render-time
        // attribute — otherwise Buy Now always buys the default variant.
        var variantField = section.querySelector('[data-variants]');
        var vid = parseInt((variantField && variantField.value) || buyNowBtn.getAttribute('data-variant-id'), 10);
        if (buyNowBtn.classList.contains('is-loading')) return;
        if (!vid) { showVariantError(); return; }
        buyNowBtn.classList.add('is-loading');
        buyNowBtn.disabled = true;
        var originalText = buyNowBtn.textContent;
        buyNowBtn.textContent = buyNowBtn.getAttribute('data-loading-text') || originalText;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: vid, quantity: 1 })
        })
        .then(function(r) {
          if (!r.ok) throw new Error('add failed');
          window.location.href = '/checkout';
        })
        .catch(function() {
          buyNowBtn.classList.remove('is-loading');
          buyNowBtn.disabled = false;
          buyNowBtn.textContent = originalText;
        });
      });
    }

    /* Language-variant validation: when a product has real variants (e.g.
       English / French), block Add to Cart and Buy Now until one is chosen,
       and show a clear message instead of silently doing nothing. Single-
       variant patterns have a hidden numeric [data-variants] value, so the
       check always passes for them. */
    var variantField = section.querySelector('[data-variants]');
    var variantError = section.querySelector('[data-variant-error]');
    var radiosFieldset = section.querySelector('.options-selection__radios');
    function variantChosen() {
      return !!variantField && /^\d+$/.test((variantField.value || '').trim());
    }
    function showVariantError() {
      if (variantError) variantError.hidden = false;
      if (radiosFieldset) radiosFieldset.classList.add('is-missing');
    }
    function clearVariantError() {
      if (variantError) variantError.hidden = true;
      if (radiosFieldset) radiosFieldset.classList.remove('is-missing');
    }
    /* Clear the message the moment a language is picked. */
    section.addEventListener('change', function(e) {
      if (e.target && e.target.matches('[data-variant-option-value]')) clearVariantError();
    });
    /* Intercept Add to Cart in the capture phase so we run before the
       theme's own ajax handler when no variant is selected. */
    var atcBtn = section.querySelector('[data-product-atc]');
    if (atcBtn && variantField) {
      atcBtn.addEventListener('click', function(e) {
        if (!variantChosen()) {
          e.preventDefault();
          e.stopImmediatePropagation();
          showVariantError();
        }
      }, true);
    }

    /* Accordion: single-open behavior + scroll-into-view on open.
       When one <details> opens, close any others inside the same accordion
       block. Then scroll the newly opened one so its content sits in view
       (browser default keeps the click position fixed, leaving the
       expanded content below the fold). */
    var accordionGroups = section.querySelectorAll('[data-accordion]');
    accordionGroups.forEach(function(group) {
      var items = group.querySelectorAll('details');
      items.forEach(function(d) {
        d.addEventListener('toggle', function() {
          if (!d.open) return;
          /* Close siblings. */
          items.forEach(function(other) {
            if (other !== d && other.open) other.open = false;
          });
          /* Slight delay lets the accordion expand before we measure. */
          setTimeout(function() {
            var rect = d.getBoundingClientRect();
            var headerOffset = 80; /* approximate top space for site header */
            var target = window.pageYOffset + rect.top - headerOffset;
            window.scrollTo({ top: target, behavior: 'smooth' });
          }, 30);
        });
      });
    });

    /* Tester highlights carousel — scroll one slide at a time on arrow
       click. Touch users swipe (CSS hides arrows on touch).
       Slides have no gap, so the step is just the slide's own width. */
    var makersTrack = section.querySelector('[data-makers-track]');
    if (makersTrack) {
      var makersPrev = section.querySelector('[data-makers-scroll="-1"]');
      var makersNext = section.querySelector('[data-makers-scroll="1"]');
      function makersStepSize() {
        var first = makersTrack.firstElementChild;
        return first ? first.getBoundingClientRect().width : 400;
      }
      function makersUpdateArrows() {
        if (!makersPrev || !makersNext) return;
        var max = makersTrack.scrollWidth - makersTrack.clientWidth;
        var x = makersTrack.scrollLeft;
        makersPrev.disabled = x <= 1;
        makersNext.disabled = x >= max - 1;
      }
      [makersPrev, makersNext].forEach(function (btn) {
        if (!btn) return;
        btn.addEventListener('click', function () {
          var dir = parseInt(btn.getAttribute('data-makers-scroll'), 10) || 0;
          makersTrack.scrollBy({ left: dir * makersStepSize(), behavior: 'smooth' });
        });
      });
      makersTrack.addEventListener('scroll', makersUpdateArrows, { passive: true });
      window.addEventListener('resize', makersUpdateArrows);
      makersUpdateArrows();
    }

    /* Tester reviews carousel — same scroll/arrow mechanics as the makers
       rail, stepping one card (plus the gap) per click. Arrows hidden on
       touch via CSS (swipe instead). */
    var testerTrack = section.querySelector('[data-tester-track]');
    if (testerTrack) {
      var tPrev = section.querySelector('[data-tester-scroll="-1"]');
      var tNext = section.querySelector('[data-tester-scroll="1"]');
      function tStep() {
        var first = testerTrack.firstElementChild;
        if (!first) return 360;
        var cs = getComputedStyle(testerTrack);
        var gap = parseFloat(cs.columnGap || cs.gap || '0') || 0;
        return first.getBoundingClientRect().width + gap;
      }
      function tArrows() {
        if (!tPrev || !tNext) return;
        /* Hide arrows entirely when everything fits (no horizontal overflow,
           e.g. 3 cards on desktop). Only show them when there's more to scroll. */
        var overflow = testerTrack.scrollWidth - testerTrack.clientWidth > 1;
        tPrev.style.display = overflow ? '' : 'none';
        tNext.style.display = overflow ? '' : 'none';
        if (!overflow) return;
        var max = testerTrack.scrollWidth - testerTrack.clientWidth;
        tPrev.disabled = testerTrack.scrollLeft <= 1;
        tNext.disabled = testerTrack.scrollLeft >= max - 1;
      }
      [tPrev, tNext].forEach(function (btn) {
        if (!btn) return;
        btn.addEventListener('click', function () {
          var dir = parseInt(btn.getAttribute('data-tester-scroll'), 10) || 0;
          testerTrack.scrollBy({ left: dir * tStep(), behavior: 'smooth' });
        });
      });
      testerTrack.addEventListener('scroll', tArrows, { passive: true });
      window.addEventListener('resize', tArrows);
      tArrows();
    }

    /* Tester review truncation: reveal "Read more" only on cards whose quote
       actually overflows the clamp, then open the full text in a modal. */
    var reviewDialog = section.querySelector('[data-review-dialog]');
    function openReview(quote, name) {
      if (!reviewDialog) return;
      var q = reviewDialog.querySelector('[data-review-quote]');
      var n = reviewDialog.querySelector('[data-review-name]');
      if (q) q.textContent = quote;
      if (n) n.textContent = name;
      document.body.classList.add('pattern-photo-lightbox-open');
      try { reviewDialog.showModal(); } catch (e) { reviewDialog.setAttribute('open', ''); }
    }
    function closeReview() {
      if (!reviewDialog) return;
      try { reviewDialog.close(); } catch (e) { reviewDialog.removeAttribute('open'); }
      document.body.classList.remove('pattern-photo-lightbox-open');
    }
    if (reviewDialog) {
      var rClose = reviewDialog.querySelector('[data-review-close]');
      if (rClose) rClose.addEventListener('click', closeReview);
      reviewDialog.addEventListener('click', function (e) { if (e.target === reviewDialog) closeReview(); });
      reviewDialog.addEventListener('close', function () { document.body.classList.remove('pattern-photo-lightbox-open'); });
    }
    Array.prototype.forEach.call(section.querySelectorAll('[data-tester-card]'), function (card) {
      var quoteEl = card.querySelector('[data-tester-quote]');
      var moreBtn = card.querySelector('[data-tester-readmore]');
      var nameEl = card.querySelector('.pattern-tester-name');
      if (!quoteEl) return;
      var fullQuote = quoteEl.textContent.trim();
      var name = nameEl ? nameEl.textContent.trim() : '';
      function checkClamp() {
        var overflowing = quoteEl.scrollHeight - quoteEl.clientHeight > 2;
        card.classList.toggle('is-clamped', overflowing);
        if (moreBtn) moreBtn.hidden = !overflowing;
      }
      checkClamp();
      window.addEventListener('resize', checkClamp);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(checkClamp);
      function open() { openReview(fullQuote, name); }
      if (moreBtn) moreBtn.addEventListener('click', function (e) { e.stopPropagation(); open(); });
      card.addEventListener('click', function () { if (card.classList.contains('is-clamped')) open(); });
    });

    /* ===== Phase 2 tester gallery — carousel + clamp + photo/review modal =====
       Photo cards in a horizontal rail. Arrows reuse the makers-arrow styling;
       they disable at the ends and hide entirely when nothing overflows. Each
       card opens a modal with the full photo + full review; the @handle links
       to Instagram. */
    var tgTrack = section.querySelector('[data-tgallery-track]');
    if (tgTrack) {
      var tgPrev = section.querySelector('[data-tgallery-scroll="-1"]');
      var tgNext = section.querySelector('[data-tgallery-scroll="1"]');
      function tgStep() {
        var first = tgTrack.firstElementChild;
        var cs = getComputedStyle(tgTrack);
        var gap = parseFloat(cs.columnGap || cs.gap) || 20;
        return first ? first.getBoundingClientRect().width + gap : tgTrack.clientWidth * 0.8;
      }
      function tgArrows() {
        var overflow = tgTrack.scrollWidth - tgTrack.clientWidth > 1;
        [tgPrev, tgNext].forEach(function (b) { if (b) b.style.display = overflow ? '' : 'none'; });
        if (!overflow || !tgPrev || !tgNext) return;
        var max = tgTrack.scrollWidth - tgTrack.clientWidth;
        tgPrev.disabled = tgTrack.scrollLeft <= 1;
        tgNext.disabled = tgTrack.scrollLeft >= max - 1;
      }
      [tgPrev, tgNext].forEach(function (btn) {
        if (!btn) return;
        btn.addEventListener('click', function () {
          var dir = parseInt(btn.getAttribute('data-tgallery-scroll'), 10) || 0;
          tgTrack.scrollBy({ left: dir * tgStep(), behavior: 'smooth' });
        });
      });
      tgTrack.addEventListener('scroll', tgArrows, { passive: true });
      window.addEventListener('resize', tgArrows);
      tgArrows();
    }

    var tgDialog = section.querySelector('[data-tgallery-dialog]');
    var tgCards = Array.prototype.slice.call(section.querySelectorAll('[data-tgallery-card]'));
    var tgIdx = 0;
    function tgShow(idx) {
      if (!tgDialog || !tgCards.length) return;
      tgIdx = (idx % tgCards.length + tgCards.length) % tgCards.length;   /* wrap */
      var card = tgCards[tgIdx];
      var img = tgDialog.querySelector('[data-tgallery-dialog-photo]');
      var nm = tgDialog.querySelector('[data-tgallery-dialog-name]');
      var hd = tgDialog.querySelector('[data-tgallery-dialog-handle]');
      var qt = tgDialog.querySelector('[data-tgallery-dialog-quote]');
      if (img) {
        /* Hide until the new photo decodes so the previous one never flashes. */
        img.style.visibility = 'hidden';
        img.onload = function () { img.style.visibility = 'visible'; };
        img.alt = card.getAttribute('data-name') || '';
        img.src = card.getAttribute('data-photo') || '';
        if (img.complete && img.naturalWidth) img.style.visibility = 'visible';   /* cached */
      }
      if (nm) nm.textContent = card.getAttribute('data-name') || '';
      if (hd) {
        var h = (card.getAttribute('data-handle') || '').trim();
        if (h) {
          hd.textContent = h;
          hd.href = 'https://www.instagram.com/' + h.replace(/^@/, '').replace(/\/+$/, '') + '/';
          hd.style.display = '';
        } else { hd.style.display = 'none'; hd.removeAttribute('href'); }
      }
      if (qt) qt.textContent = card.getAttribute('data-quote') || '';
      /* Reset scroll to the top on open/navigate so the modal always starts at the top of
         the photo (the scroll container is .ptg-dialog-grid on mobile, .ptg-dialog-body's
         own scroll on desktop) — otherwise it lands mid-photo and looks "zoomed". */
      var body = tgDialog.querySelector('.ptg-dialog-body');
      if (body) body.scrollTop = 0;
      var grid = tgDialog.querySelector('.ptg-dialog-grid');
      if (grid) grid.scrollTop = 0;
    }
    function tgOpen(idx) {
      if (!tgDialog) return;
      tgShow(idx);
      document.body.classList.add('pattern-photo-lightbox-open');
      try { tgDialog.showModal(); } catch (e) { tgDialog.setAttribute('open', ''); }
    }
    function tgClose() {
      if (!tgDialog) return;
      try { tgDialog.close(); } catch (e) { tgDialog.removeAttribute('open'); }
      document.body.classList.remove('pattern-photo-lightbox-open');
    }
    if (tgDialog) {
      var tgCls = tgDialog.querySelector('[data-tgallery-close]');
      var tgPv = tgDialog.querySelector('[data-tgallery-dialog-prev]');
      var tgNx = tgDialog.querySelector('[data-tgallery-dialog-next]');
      if (tgCls) tgCls.addEventListener('click', tgClose);
      if (tgPv) tgPv.addEventListener('click', function (e) { e.stopPropagation(); tgShow(tgIdx - 1); });
      if (tgNx) tgNx.addEventListener('click', function (e) { e.stopPropagation(); tgShow(tgIdx + 1); });
      tgDialog.addEventListener('click', function (e) { if (e.target === tgDialog) tgClose(); });
      tgDialog.addEventListener('close', function () { document.body.classList.remove('pattern-photo-lightbox-open'); });
      tgDialog.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); tgShow(tgIdx - 1); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); tgShow(tgIdx + 1); }
      });
    }
    tgCards.forEach(function (card, idx) {
      var quoteEl = card.querySelector('[data-tgallery-quote]');
      var moreBtn = card.querySelector('[data-tgallery-more]');
      function checkClamp() {
        if (!quoteEl) return;
        var overflowing = quoteEl.scrollHeight - quoteEl.clientHeight > 2;
        if (moreBtn) moreBtn.hidden = !overflowing;
      }
      checkClamp();
      window.addEventListener('resize', checkClamp);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(checkClamp);
      if (moreBtn) moreBtn.addEventListener('click', function (e) { e.stopPropagation(); tgOpen(idx); });
      card.addEventListener('click', function () { tgOpen(idx); });
      /* Keyboard: the card is role="button" tabindex="0" (see Liquid) so Enter/Space open the modal. */
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); tgOpen(idx); }
      });
    });

    /* Empty-reviews "Write a review": our visible button forwards the click to
       Judge.me's hidden trigger (so the styled button isn't hidden by JM's CSS). */
    var reviewOpen = section.querySelector('[data-review-open]');
    if (reviewOpen) {
      reviewOpen.addEventListener('click', function () {
        var jm = section.querySelector('.jdgm-write-rev-link');
        if (jm) jm.click();
      });
    }

    /* Cross-sell: fetch Shopify product recommendations.
       If the endpoint returns an empty grid (no recommendations available),
       keep the server-rendered fallback in place instead of wiping it. */
    var recBox = section.querySelector('[data-recommendations]');
    if (recBox) {
      var url = recBox.getAttribute('data-url');
      fetch(url)
        .then(function(r) { return r.text(); })
        .then(function(html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var grid = doc.querySelector('[data-recommendations]');
          if (grid && grid.children.length > 0) {
            recBox.innerHTML = grid.innerHTML;
          }
        })
        .catch(function() { /* silent — fallback stays */ });
    }
  });
})();
